<div class="button-loader">
  <div class="button-loader__button">
    <img class="button-loader__3d-arrow" src="assets/images/widget/loading_experience/interact-in-3d-arrow.svg">
    <div class="button-loader__label">Interact in 3D</div>
  </div>
</div>